const DateTimeFunc = require('@/tbs/util/DateTimeFunc')

/**
 * The Player class acts as the view object for the player.
 */
const tbs_model_vo_MatchSuspensionReport = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_MatchSuspensionReport.prototype = {
    /* The view object name */
    name: 'report',
    /* The view object instance */
    view: {
        query: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'getMatchNewsList',
            basePath: 'data.list',
            rule: {
                id: 'id',
                title: 'title',
                url: '$id',
                createTimeLabel: '$createDate',
            }
        }
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderUrl: function(id) {
        console.log('@renderUrl', process.env.VUE_APP_REPORT_URL)
        return process.env.VUE_APP_REPORT_URL + '?redirect=news-detail?v=2&newsId=' + id
    },
    renderCreateTimeLabel: function(createDate) {
        const createTimeStr = DateTimeFunc.formatDate(new Date(createDate), 'yyyy-MM-dd')
        const nowYear = (new Date).getFullYear()
        return createTimeStr.replace(nowYear + '-', '')
    }
}

module.exports = tbs_model_vo_MatchSuspensionReport